import { Currency } from "config/constants"
import tenantSettingsStore from "stores/tenantSettings"

interface IGetCustomerBasedCurrencyParams {
    hasCustomer: boolean
    customerCurrency?: Currency | null
}

export default function getCustomerBasedCurrency({
    hasCustomer,
    customerCurrency,
}: IGetCustomerBasedCurrencyParams): Currency | null {
    if (!hasCustomer)  {
        return null
    }
    if (customerCurrency) {
        return customerCurrency
    }
    const tenantCurrency = tenantSettingsStore.$tenantSettings.getState()?.defaultCurrency
    return tenantCurrency || null
}
